import ko from 'knockout'
import template from './starter.image.tpl.html'
import { IStarterImageViewModelParams, StarterImageViewModel } from './StarterImageViewModel'

if (!ko.components.isRegistered('starter-image')) {
  ko.components.register('starter-image', {
    viewModel: {
      createViewModel: (params: IStarterImageViewModelParams) => {
        const viewModel = new StarterImageViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
